import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { AlertTriangleIcon } from 'lucide-react';
export function UrgencySection() {
  return <section className="py-16 px-4 bg-red-600 text-white text-center" data-id="element-322">
      <div className="max-w-4xl mx-auto" data-id="element-323">
        <div className="flex justify-center mb-6" data-id="element-324">
          <AlertTriangleIcon className="w-16 h-16 text-yellow-300 animate-pulse" data-id="element-325" />
        </div>
        <h2 className="text-3xl md:text-4xl font-bold mb-6 uppercase tracking-wide" data-id="element-326">
          OFFERTA SPECIALE A TEMPO LIMITATO
        </h2>
        <p className="text-xl md:text-2xl text-red-100 mb-8 font-medium" data-id="element-327">
          I 4 bonus gratuiti saranno rimossi al termine del countdown. Non
          perdere questa opportunità!
        </p>

        <div className="bg-red-700/50 backdrop-blur-sm border border-red-500 rounded-2xl p-6 md:p-8 inline-block shadow-xl" data-id="element-328">
          <p className="text-white font-bold mb-4 text-lg uppercase tracking-wider" data-id="element-329">
            L'offerta scade tra:
          </p>
          <CountdownTimer light data-id="element-330" />
        </div>
      </div>
    </section>;
}